// - 成员管理页面公用方法
import { defineAsyncComponent } from 'vue'
import { getdeptlist } from '@/port/schoolInstrument/appConfig.js'
import { getchildorg } from '@/port/admins/organizationUser'
export default {
  components: {
    DemoPageHeader: defineAsyncComponent(() => import('../memberManagement/comment/PageHeader/index')),
    Vue2OrgTree: defineAsyncComponent(() => import('../memberManagement/comment/org-tree.vue')),
    pikaluonti: defineAsyncComponent(() => import('../memberManagement/pikaluonti/index')),
    batchCreate: defineAsyncComponent(() => import('../memberManagement/batchJexcel/batchCreate.vue'))
  },
  data () {
    return {
      // - type: 1->教育局;2->校管辖单位;3->机构;4->学校;5->校区;6->学段;7->年段;8->班级;9->行政部门;
      treeData: [], // - 组织树图数据
      per: 3, // - 当前登录用户的角色：1平民，2：部门管理员，3：系统管理员
      schoolType: 1, // - 当前登录组织类型： 1：学校类型 2： 教育局类型
      // 水平还是竖直，值为true 或 false
      horizontal: true,
      // 折叠效果，值为true 或 false
      collapsable: true,
      // labelClassName: "bg-white",//- 修改背景色，支持自定义类名
      BasicSwich: false,
      BasicInfo: { id: null, label: null },
      // 批量添加组织对象数据(大刘)
      pikaluontiDatas: {},
      // - 批量增加学校部门显示参数(大刘)
      pikaluontiShow: false,
      // - 批量显示参数(童)
      batchShow: false,
      // - 批量添加组织对象数据(童)
      batchDatas: {},
      // - 批量添加组织对象区分批量创建和批量导入管理员
      batchDatasType: '',
      // - 组织loading
      loading: false,
      // 自定义类型
      customizeType: {},
    }
  },
  mounted () {
    // - 两个页面公用方法
  },
  methods: {
    // 查询自定义类型
    async getCustomizeType() {
      const __par = {
        curpage: 1,
        pagesize: 9999
      }
      if (this.spaceid && this.isSpace) __par.spaceid = this.spaceid
      const res = await this.$http.getOpenDepttiplist(__par)
      if (res.code === 0) {
        const obj = {}
        for (const i of res.data) {
          obj[i.deptTipId] = {
            label: i.name,
            type: i.type
          }
        }
        this.customizeType = obj
      }
    },
    // - 判断不同场景进入后显示树图的渲染是否是第一次渲染
    judgeFirst (first) {
      let whether = false
      // - 说明当前树状图是管理第一次加载列表，属于特殊处理
      if (first && this.per === 2 && this.treeType === 'normal') {
        whether = true
      }
      // - 说明当前树状图是管理搜索第一次加载列表，属于特殊处理
      if (first && this.treeType === 'search') {
        whether = true
      }
      return whether
    },
    // - 童，大刘的批量和单个修改和编辑的回调后修改显示数据
    async changListFun (callDatas) {
      const that = this
      if (callDatas && callDatas.leval) {
        let orgInfo
        // return
        if (parseInt(callDatas.id) !== -1) {
          orgInfo = await that.$http.getSchoolInfoGetorg({
            organizationId: callDatas.id
          })
        }

        let callDatasLeval = callDatas.leval
        callDatasLeval = callDatasLeval.split('_')
        // - 这是修改编辑，或者批量，单独新增子集数据
        // - 统一dom节点重新渲染
        let dom = that.treeData
        const lastLength = callDatasLeval.length
        callDatasLeval.forEach((item, index) => {
          if ((index + 1) === lastLength) {
            // - 最后一项
            dom = dom[item]
          } else {
            // - 除了最后一项的前几项
            if (dom[item].children) {
              dom = dom[item].children
            }
          }
        })
        console.log('找到节点的dom===>', dom, callDatas)

        if (dom) {
          // - 说明找到当前节点
          dom.expand = false
          dom.isMore = parseInt(callDatas.id) === -1 ? true : orgInfo.data.lst
          dom.children = []
          if (callDatas.name) {
            // - 编辑后，重新渲染名称
            dom.label = callDatas.name
          }
          that.treeForceUpdate(callDatas)
        }
      }
    },
    // - 获取成员管理列表
    async getList ({ page, nowTreeData, requestid, name, first, orgtype, openspace }) {
      // - page: 当前请求第几页数；requestid：当前层级组织id，nowTreeData:当前添加dom层级数据,name: 搜索名称
      this.loading = true
      // pagesize 用模式判断，管理模式为 9999 统计模式要分页为 10
      // 客户端的接口没有判断下级是否有子组织
      const obj = {
        curpage: page,
        pagesize: 10,
        pid: requestid || undefined,
        name: name || undefined
      }
      if(typeof orgtype !== 'undefined'){
        obj.type = orgtype
      }
      if(typeof openspace !== 'undefined'){
        obj.openspace = openspace
      }
      if (this.spaceid && this.isSpace) obj.spaceid = this.spaceid
      const res = await getdeptlist(obj)
      if (res.code === 0 && res.data && res.data.length > 0) {
        const list = res.data
        // eslint-disable-next-line no-mixed-operators
        if (!first || first && this.treeType === 'normal') {
          // - 组织结构的分页只适用子节点或者成员管理第一次搜索并且为用户角色系统管理员
          nowTreeData.expand = true
          nowTreeData.isMore = false
          // - 判断是否显示分页数据
          if (res.total > (page * res.pagesize)) {
            // - 说明有分页
            nowTreeData.pageData = {
              nowPage: page,
              totalPage: Math.ceil(res.total / res.pagesize)
            }
          }
        } else {
          // - 组织结构的第一次初始层级是否需要分页
          if (this.treeType === 'normal') {
            // - 成员管理
            this.nowPagination.first.total = res.total
          } 
          // else if (this.treeType === 'search') {
          //   // - 成员管理搜索
          //   this.pagination[this.activeName].total = res.total
          // }
        }
        let treeDataChildren = nowTreeData.children
        const father_leval = nowTreeData.leval
        // - 判断不同场景进入后显示树图的渲染是否是第一次渲染,数据插入的节点是本身还是children
        if (this.judgeFirst(first) === true) {
          treeDataChildren = nowTreeData
        }
        // - 改造显示数据
        list.forEach((item, index) => {
          const pushData = {
            isMore: item.lst,
            lst: item.lst,
            id: item.organizationId,
            pid: item.pid,
            label: item.name,
            dept: item.dept,
            leval: this.judgeFirst(first) === true ? index.toString() : father_leval + '_' + index,
            type: item.type ? item.type : '' // - 旧数据默认没有类型，用机构类型展示
          }
          if (item.configs) pushData.configs = item.configs
          // - 后台告知当前子集的下级还有子集内容
          if (item.lst) {
            pushData.children = []
          }
          treeDataChildren.push(pushData)
        })
        // - 第一次渲染组织数据不需要重新渲染
        // - 但是如果是成员管理第一次，则需要重新渲染
        if (!first) {
          this.treeForceUpdate(nowTreeData)
        }
        if (first && this.treeType == 'normal' && this.per !== 2) {
          nowTreeData.expand = true
          this.treeForceUpdate(nowTreeData)
        }
        this.loading = false
      } else if (res.code === 0 && res.data && res.data.length === 0) {
        // - 组织结构的第一次初始层级是否需要分页
        if (this.treeType === 'normal') {
          // - 成员管理
          this.nowPagination.first.total = 0
        } 
        // else if (this.treeType === 'search') {
        //   // - 成员管理搜索
        //   this.pagination[this.activeName].total = 0
        // }
        this.loading = false
      }
    },
    // - 强制树图更新
    treeForceUpdate (data) {
      if (!data) {
        return
      }
      const leval = data.leval
      console.log('解析的', leval)
      const levalArray = leval.split('_')
      const index = levalArray.length > 0 ? levalArray[0] : 0
      // - 强制树图更新,正常树状图,搜索树状图
      this.$refs.vue2OrgTree[index].$forceUpdate()
    },
    // - 删除框
    deleteOrganization (deleteDatas) {
      const that = this

      that.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteAction(deleteDatas)
      }).catch(() => {

      })
    },
    // - 删除当前组织
    async deleteAction (deleteDatas) {
      const that = this
      const res = await that.$http.deleteMember({
        organizationId: deleteDatas.id
      })
      if (res.code === 0) {
        // - 删除子集数据
        that.listDelete(JSON.parse(JSON.stringify(deleteDatas)))
      }
    },
    // - 列表删除子集数据
    listDelete (callDatas) {
      const that = this
      if (callDatas && callDatas.leval) {
        let callDatasLeval = callDatas.leval
        callDatasLeval = callDatasLeval.split('_')
        let dom = that.treeData

        const lastLength = callDatasLeval.length
        let error = false
        let fatherDom = ''

        callDatasLeval.forEach((item, index) => {
          if ((index + 1) === lastLength) {
            // - 最后一项
            dom.splice(item, 1)
            // - 删除完后leval数据需要重新排序
            dom.forEach((item2, index2) => {
              if (!item2.leval) return
              let nowLeval = JSON.parse(JSON.stringify(item2.leval))
              nowLeval = nowLeval.split('_')
              nowLeval.splice(nowLeval.length - 1, 1)
              nowLeval.push(index2.toString())
              nowLeval = nowLeval.join('_')
              item2.leval = nowLeval
            })
          } else {
            // - 除了最后一项的前几项
            console.log('查看', dom[item].children)
            if (dom[item].children) {
              fatherDom = dom[item]
              dom = dom[item].children
            } else {
              error = true
            }
          }
        })

        console.log('找到节点的dom===>', dom)

        if (dom && error !== true) {
          console.log('callDatas', callDatas, fatherDom)
          // - 说明找到当前节点
          console.log('fatherDom.pageData', fatherDom)
          if (fatherDom && fatherDom.children.length === 0 && fatherDom.pageData && fatherDom.pageData.nowPage > 1) {
            // - 说明当前场景是删除某非第一页面的其他页最后一条数据，需要重新渲染上一页数据
            fatherDom.pageData.totalPage = fatherDom.pageData.totalPage - 1
            that.onPageChangeDelete('', fatherDom)
          } else {
            that.treeForceUpdate(callDatas)
          }
        } else {
          that.$message.error('没有找到节点，请重新刷新页面')
        }
      }
    },

    // - 童：关闭批量添加学校部门组件回调
    batchClose (callDatas) {
      this.batchShow = false
      this.batchDatas = {}
      this.batchDatasType = ''
      this.changListFun(JSON.parse(JSON.stringify(callDatas)))
    },
    // - 大刘：关闭批量添加学校部门组件回调
    closePikaluonti (callDatas) {
      this.pikaluontiShow = false
      this.pikaluontiDatas = {}
      this.changListFun(JSON.parse(JSON.stringify(callDatas)))
    },
    // 创建组织
    async onClickOrganization (type, val, data) {
      console.log(type, val, data);
      // - val: 当前按钮的状态
      data = JSON.parse(JSON.stringify(data))
      if (type === 1) {
        data.children = []
        // - 童的批量创建
        if (data.type && data.type < 4 || data.type === 9) {
          // 批量添加学校部门
          this.batchDatasType = val
          this.batchDatas = { ...data }
          this.batchShow = true
        }
        // - 大刘的批量创建
        if (data.type && data.type >= 4 && data.type !== 9) {
          // 批量添加学校部门
          this.pikaluontiDatas = { ...data }
          this.pikaluontiShow = true
        }
      } else if (type === 2) {
        const that = this
        // - 童的子组织创建和编辑
        that.$router.push({
          path: '/diagrams/upUser/' + data.id,
          query: {
            title: data.label,
            type: data.type,
            state: val,
            leval: data.leval,
            treeTypeIndex: that.treeType
          }
        })
      } else if (type === 3) {
        // 客户端的接口没有判断下级是否有子组织
        const __par = { pid: data.organizationId }
        if (this.spaceid && this.isSpace) __par.spaceid = this.spaceid
        const res = await getchildorg(__par)
        if (res.code === 0) {
          if (res.data.length === 0) return this.$message.info('该组织下没有子级组织！')
          window.sessionStorage.setItem('adminOrg', JSON.stringify(res))
          // - 童的批量添加学校部门,批量导入管理员
          this.batchDatasType = val
          this.batchDatas = { ...data }
          this.batchShow = true
        }
      }
    },
    // 新增hover功能（jsx结构）
    renderContent (h, data) {
      // type: 1->教育局;2->校管辖单位;3->机构;4->学校;5->校区;6->学段;7->年段;8->班级;9->行政部门;
      // console.log("renderContent",h, data)
      // 客户端空间管理不需要该功能，先隐藏 2023.4.26
      return (<el-popover
        placement="top-start"
        width="200"
        trigger="hover">
        <div class="el-dropdown-content">
          <div class="dropdownDiv" v-show={data.type !== -1 && data.id !== -1}>
            <div class="title">部门管理:{this.showName(data.type)}</div>
            <div class="item" onclick={() => this.onClickOrganization(2, 'edit', data, this)}>编辑</div>
            <div class="item red" onclick={() => this.deleteOrganization(data)}>删除</div>
          </div>
          <div class="dropdownDiv" v-show={data.type !== 8 && data.type !== ''}>
            <div class="title">{data.type === -1 ? '创建组织' : '子级组织管理'}</div>
            <div class="item" v-show={data.type < 4 || data.type === 9 || data.type > 9} onclick={() => this.onClickOrganization(2, 'add', data, this)}>添加子级组织</div>
            <div class="item" v-show={data.type < 4 || data.type === 9} onclick={() => this.onClickOrganization(1, 1, data, this)}>批量创建</div>
            <div class="item" v-show={data.type !== -1 && data.lst === true} onclick={() => this.onClickOrganization(3, 2, data, this)}>批量导入管理员</div>
            <div class="item" v-show={data.type >= 4 && data.type < 7} onclick={() => this.onClickOrganization(1, '', data, this)}>快速创建</div>
            <div class="item" v-show={data.type === 4 || data.type === 5} onclick={() => this.onClickOrganization(3, 4, data, this)}>创建行政部门</div>
            <div v-show={data.type === 7}>
              <div class="item" onclick={() => this.onClickOrganization(1, '', data, this)}>创建行政班</div>
              <div class="item" onclick={() => this.onClickOrganization(3, 3, data, this)}>创建自定义班级</div>
            </div>
          </div>

        </div>
        <div class="el-drop-text" slot="reference">{data.label}</div>

      </el-popover>)
    },
    // - 展示名称
    showName (type) {
      let name = ''
      switch (type) {
        case -1 || '':
          // - 初始层级
          name = ''
          break
        case 1:
          // - 教育局
          name = '教育局'
          break
        case 2:
          // - 校管辖单位
          name = '校管辖单位'
          break
        case 3:
          // - 机构
          name = '机构'
          break
        case 4:
          // - 学校
          name = '学校'
          break
        case 5:
          // - 校区
          name = '校区'
          break
        case 6:
          // - 学段
          name = '学段'
          break
        case 7:
          // - 年段
          name = '年段'
          break
        case 8:
          // - 班级
          name = '班级'
          break
        case 9:
          // - 行政部门
          name = '行政部门'
          break
      }
      return name
    },
    // - 折叠效果判断
    collapse (list) {
      const that = this
      list.forEach((item) => {
        if (item.expand) {
          item.expand = false
        }
        item.children && that.collapse(item.children)
      })
    },
    // - 定义折叠的组织结构如何展开，该函数参数必须传两个，第一个是 e ，第二个是 data
    onExpand (e, data) {
      if ('expand' in data) {
        data.expand = !data.expand
        if (!data.expand && data.children) {
          this.collapse(data.children)
        }
      } else {
        data.expand = true
      }
      this.treeForceUpdate(data)
    },

    // - 是否全部展开
    toggleExpand (data, val) {
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          item.expand = val
          if (item.children) {
            item.children = val
          }
        })
      } else {
        data.expand = val
        if (data.children) {
          this.toggleExpand(data.children, val)
        }
      }
    },
    // - 鼠标移出块
    onMouseout () {
      this.BasicSwich = false
    },
    // - 鼠标移入块
    onMouseover (e, data) {
      this.BasicInfo = data
      this.BasicSwich = true
      var floating = document.getElementsByClassName('floating')[0]
      floating.style.left = (e.clientX - 200) + 'px'
      floating.style.top = (e.clientY - 100) + 'px'
    },
    // - 分页操作(下一页)
    onPageChangeAdd (e, data) {
      const pageData = data.pageData
      if (!pageData) {
        this.$message.error('分页数据有误')
      }
      if (pageData.nowPage < pageData.totalPage) {
        pageData.nowPage++
        data.children = []
        this.getList({ page: pageData.nowPage, nowTreeData: data, requestid: data.id })
      } else {
        pageData.nowPage = pageData.totalPage
      }
    },
    // - 分页操作(上一页)
    onPageChangeDelete (e, data) {
      const pageData = data.pageData
      console.log('data', data)
      if (!pageData) {
        this.$message.error('分页数据有误')
      }

      if (pageData.nowPage > 1) {
        pageData.nowPage--
        data.children = []
        this.getList({ page: pageData.nowPage, nowTreeData: data, requestid: data.id })
      } else {
        pageData.nowPage = 1
      }
    },
    // - 加载更多
    onPageChangeMore (e, data) {
      this.getList({ page: 1, nowTreeData: data, requestid: data.id })
      e.stopPropagation(); //阻止穿透调用onNodeClick()
    },
    // 进入空间
    onNodeClick(e, val){
      console.log(e,val);
      if(val.dept.openspace == 1){
        localStorage.setItem('spaceid',val.id)
        this.$openAdmin({ path: '/cust/main/spaceMain/home' }, { isNewTab: true })
      }
    },

  },
  // - keep-alive deactivated退出
  deactivated () {
    console.log('keep-alive deactivated退出')
  },

  // - keep-alive activated 进入
  activated () {
    // this.$refs.header.focusInput();
    console.log('keep-alive activated进入', this.$route.params)
    if (this.$route.params) {
      this.changListFun(JSON.parse(JSON.stringify(this.$route.params)))
    }
    // if(this.treeType === 'search'){
    //   this.$refs.header.focusInput();
    // }
  }
}
